import dayjs from 'dayjs';
export function addMonths(date, months) {
    return dayjs(date).add(months, 'month').toDate();
}
export function formatDateShort(date) {
    var day = date.getDate().toString().padStart(2, '0');
    var month = date.toLocaleString('en-us', { month: 'short' });
    var year = date.getFullYear().toString().slice(2);
    return "".concat(day, " ").concat(month, " ").concat(year);
}
